//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HFVALIANTRISKSCORE',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: ''
      },
      dataList1: [
        {name: '≤50岁', value: '0'},
        {name: '51~60岁', value: '4'},
        {name: '61~70岁', value: '5'},
        {name: '71~80岁', value: '9'},
        {name: '>80岁', value: '10'}
      ],
      dataList2: [
        {name: '白种人或亚洲人', value: '0'},
        {name: '非裔美国人', value: '6'},
        {name: '其他种族', value: '4'}
      ],
      dataList6: [
        {name: '无新发LBBB', value: '0'},
        {name: '有新发LBBB', value: '5'}
      ],
      dataList3: [
        {name: '无', value: '0'},
        {name: '有', value: '5'}
      ],
      dataList7: [
        {name: '1级或2级', value: '0'},
        {name: '3级或4级', value: '3'}
      ],
      dataList8: [
        {name: 'I级', value: '0'},
        {name: 'II级', value: '3'},
        {name: 'III级', value: '5'},
        {name: 'IV级', value: '9'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }

      if (result >= 0 && result <= 5) {
        self.descTxt = '3年内心衰发生风险2.3%'
      } else if (result >= 6 && result <= 8) {
        self.descTxt = '3年内心衰发生风险5.1%'
      } else if (result >= 9 && result <= 11) {
        self.descTxt = '3年内心衰发生风险8%'
      } else if (result >= 12 && result <= 14) {
        self.descTxt = '3年内心衰发生风险12.2%'
      }else if (result >= 15 && result <= 17) {
        self.descTxt = '3年内心衰发生风险18.4%'
      }else if (result >= 18 && result <= 20) {
        self.descTxt = '3年内心衰发生风险24.7%'
      }else if (result >= 21 && result <= 23) {
        self.descTxt = '3年内心衰发生风险29.8%'
      }else if (result >= 24) {
        self.descTxt = '3年内心衰发生风险33.3%'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/HFVALIANTRISKSCORE.vue